export default __webpack_public_path__ + "static/frontpage-d89f6616148289e4f2ec041cacc52b62.jpg";